export default "__VITE_ASSET__DSrjQMBa__"